import '../../node_modules/ui-theme/js/components/tabs';
UX.tab.on.dropdownBuild = function (elem, index) {
    // rebuild tabs to be as drop down
    if (UX.dropBlock) {
        UX.dropBlock.init();
    }

    elem.wrap('<div class="dropBlock" data-db-parent-of="dbTab-' + index + '"></div>');

    const $dropdownContainer = elem.closest('.dropBlock');
    const $activeTab = elem.find('.active a');

    $dropdownContainer.prepend(
        '<a href="#" title ="search dropdown" class="dropBlock__link" data-db-target-for="dbTab-' +
            index +
            '"><span>' +
            $activeTab.text() +
            '</span><i class="icon-arrow_d_n" aria-hidden="true"></i></a>'
    );
    elem.attr('data-db-target-of', 'dbTab-' + index);
};
